module.exports = __webpack_public_path__ + "static/img/PR_pur_selected@3x.8628839b.png";